import { API, getAsyncThunk } from 'app/api';

export const getMatchResultDetails = getAsyncThunk(
  'MATCH_RESULT:GET_MATCH_DETAILS',
  API.matches.getMatchResultDetails,
);

export type MatchResultDetailsPending = ReturnType<typeof getMatchResultDetails.pending>;
export type MatchResultDetailsSuccess = ReturnType<typeof getMatchResultDetails.fulfilled>;
export type MatchResultDetailsFailure = ReturnType<typeof getMatchResultDetails.rejected>;
